export const registerPwa = () => {
  if (!("serviceWorker" in navigator)) {
    return
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Le site demeure entièrement utilisable si l'installation PWA n'est pas offerte.
    })
  })
}
